<template xmlns:v-bind="http://www.w3.org/1999/xhtml" xmlns:v-el="http://www.w3.org/1999/xhtml">
  <div
    v-if="!isSidekickOrganization"
    class="email-notifications-container">
    <drop-down
      :label="capitalize($t('names.notification', { n: 2 }))"
      :popup-label="capitalize($t('messages.manageEmailNotifications'))"
      :options="notificationsInternal"
      :selected-options="activeNotifications"
      :use-checkboxes="false"
      :select-all-by-default="false"
      :show-summary-of-selections-instead-of-label="false"
      :tint-when-selections="false"
      :icon="iconEmail"
      :use-alternate-style="true"
      :align-drop-down-to-right="true"
      :show-select-all="false"
      :show-clear="false"
      :mark-as-having-selections-when-all-are-selected="true"
      :return-empty-selected-options-when-all-is-selected="false"
      @toggle-option-changed="onToggleOptionChanged" />
  </div>
</template>

<script type="text/babel">
  import { capitalize, markRaw } from 'vue';
  import { mapGetters } from 'vuex';

  import { DropDown } from '@/common/components/controls';
  import { IconEmail } from '@/common/icons/monochrome';

  export default {
    components: {
      DropDown,
    },
    props: {
      notifications: {
        type: Array,
        default: () => [],
      },
      activeNotifications: {
        type: Array,
        default: null,
      },
    },
    data() {
      return {
        iconEmail: markRaw(IconEmail),
        notificationsInternal: [],
        subscriptionInProgress: [],
      };
    },
    computed: {
      ...mapGetters('orgApp', ['isSidekickOrganization']),
    },
    watch: {
      notifications() {
        this.notificationsInternal = this.notifications.map((option) => ({ ...option, isReadOnly: false }));
      },
    },
    mounted() {
      this.notificationsInternal = this.notifications.map((option) => ({ ...option, isReadOnly: false }));
    },
    methods: {
      capitalize,
      markRaw,
      async onToggleOptionChanged(change, isSelected) {
        change.isReadOnly = true;
        this.subscriptionInProgress.push(change);
        if (isSelected) {
          await change.subscribe();
        } else {
          await change.unsubscribe();
        }
        this.notificationsInternal = this.notificationsInternal.map((option) =>
          option.id === change.id ? { ...option, isReadOnly: false } : option,
        );
        this.subscriptionInProgress = this.subscriptionInProgress.filter((x) => x.id !== change.id);
      },
    },
  };
</script>
